const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlacement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 508 508",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#90DFAA"
    },
    d: "M508,254c0,140.4-113.6,254-254,254S0,394.4,0,254S113.6,0,254,0c110.8,0,204.8,70.8,239.6,169.6 c7.6,21.2,12,43.6,13.6,66.8C508,242.4,508,248,508,254z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E9EE"
    },
    points: "301.6,183.6 297.6,284.4 210.4,284.4 206.4,183.6 254,160.4 "
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F9B54C"
    },
    cx: 254,
    cy: 172.4,
    rx: 30.4,
    ry: 30.8
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F1543F"
    },
    points: "266.8,203.2 241.2,203.2 246,218 262,218 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF7058"
    },
    points: "271.2,284.4 236.8,284.4 246,218 262,218 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3B4E"
    },
    d: "M333.2,256l0.8,13.2c0,2.8,2.8,5.2,5.6,5.2c0,0,0,0,0.4,0c0.4,3.6,1.2,6.8,1.6,10h-68 c6.4-20.4,10.4-39.2,12.8-55.6c0.4,0.8,8.8-31.2,4-50.8l59.2,28.8l0.4,2.8c-5.6,4.4-9.2,10.4-10,18.4s-1.2,15.6-1.2,22.4h-0.4 C335.2,250.4,332.8,252.8,333.2,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3B4E"
    },
    d: "M174.8,256L174.8,256c0-3.2-2.4-5.2-5.2-5.2h-0.4c0-6.8-0.4-14.4-1.2-22.4s-4.8-14-10-18.4l0.4-2.8 l59.2-29.2c-4.4,18.8,3.6,49.6,4,50.4l0,0c2.4,16.4,6.4,35.2,12.8,55.6h-68c0.8-3.2,1.2-6.4,1.6-10c0,0,0,0,0.4,0 c2.8,0,5.6-2.4,5.6-5.2L174.8,256z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M283.6,166c0,0,4,21.2-29.6,37.2c0,0,24.8,2,32.4,25.2C286.4,229.6,300,178.4,283.6,166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M224.4,166c0,0-4,21.2,29.6,37.2c0,0-24.8,2-32.4,25.2C221.6,229.6,208,178.4,224.4,166z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M303.6,109.2c0,32.4-22,72.4-49.6,72.4c-27.2,0-49.6-40-49.6-72.4S226.4,64,254,64 C281.2,64,303.6,76.8,303.6,109.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M236.8,57.2c0,0,40-16,60.4,20.4c22,38.8-5.6,80.8-11.2,84.4c0,0,1.6-6.8,5.6-19.6 c0,0,9.6-28.8-19.6-33.2c0,0-28.4-4-30.8-10c0,0,2,10.4,14.8,12.4c0,0-29.2-0.8-38.4-11.2c0,0-12.4,41.2,5.6,63.6 c0,0-31.6-25.2-27.6-64.4C196,100,194.4,46.4,236.8,57.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C9984"
    },
    d: "M2,284.4C16.8,410.4,124,508,254,508s237.2-97.6,252-223.6H2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M168.4,274L168.4,274c-2.8,0-5.2-2.4-5.2-5.2l0.8-13.2c0-2.8,2.8-5.2,6-5.2l0,0 c3.2,0,5.2,2.4,5.2,5.2l-1.2,13.2C174,272,171.2,274,168.4,274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M72,274L72,274c-3.2,0-5.6-2.4-6-5.2l-0.8-13.2c0-2.8,2-5.2,5.2-5.2h0.4 C70.8,259.2,71.2,267.2,72,274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M153.6,341.2c0.8-2.8,1.2-5.6,1.2-8.8c0-19.2-15.6-34.8-34.4-34.8c-19.2,0-34.4,15.6-34.4,34.8 c0,3.2,0.4,6,1.2,8.8H153.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M168,228c-2.4-24-32.4-30.4-47.6-30.4l0,0c0,0,0,0-0.4,0c0,0,0,0-0.4,0l0,0 c-15.2,0-44.8,6.4-47.6,30.4c-4,37.2,0.8,61.6,8.8,77.6c4.8,9.6,14.8,16,26,16h26c10.8,0,20.8-6,26-16 C167.2,289.6,172,265.2,168,228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M83.2,394.8c0.4-0.4,0.8-0.8,1.2-1.2c-0.4,0.8-0.4,1.6-0.8,2C83.6,396,83.6,395.6,83.2,394.8z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M161.6,338.8c-39.2,22.8-74.8,4.8-82.4,0c1.2-6,3.6-10.8,7.6-13.6c0,0,31.6,27.6,67.2,0 C157.6,328,160,332.8,161.6,338.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M156,393.6c0.4,0.4,0.8,0.8,1.2,1.2c0,0.8-0.4,1.2-0.4,1.2C156.4,395.2,156.4,394.4,156,393.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M236.8,396c-5.2-16-16.4-29.2-31.6-36.4l-43.6-21.2l0,0c-39.2,22.8-74.8,4.8-82.4,0l0,0l-44,21.2 c-3.2,1.6-6.4,3.6-9.6,6c40,82,123.6,139.6,220.4,142.4v-52C246,435.2,242.8,415.2,236.8,396L236.8,396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M181.6,383.6H58.4c-7.2,0-13.6,2.4-18.8,6.8c38,59.2,99.6,102,171.6,114v-90.8 C211.6,397.2,198,383.6,181.6,383.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M436,274L436,274c-2.8,0-5.2-2.4-5.2-5.2l0.8-13.2c0-2.8,2.8-5.2,6-5.2l0,0c3.2,0,5.2,2.4,5.2,5.2 l-0.8,13.2C441.6,272,439.2,274,436,274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M340,274C339.6,274,339.6,274,340,274c-3.2,0-5.6-2.4-6-5.2l-0.8-13.2c0-2.8,2-5.2,5.2-5.2h0.4 C338.4,259.2,338.8,267.2,340,274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M421.6,325.2C421.6,325.2,421.6,324.8,421.6,325.2c-35.6,27.2-67.6,0-67.6,0l0,0 c0.8-3.2,2-6.4,3.6-9.6c4.8,3.6,10.8,5.6,17.2,5.6h26c6.4,0,12.4-2,17.2-5.6C420,318.4,420.8,321.6,421.6,325.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M435.6,228c-2.4-24-32.4-30.4-47.6-30.4l0,0c0,0,0,0-0.4,0c0,0,0,0-0.4,0l0,0 c-15.2,0-44.8,6.4-47.6,30.4c-4,37.2,0.8,61.6,8.8,77.6c4.8,9.6,14.8,16,26,16h26c10.8,0,20.8-6,26-16 C434.8,289.6,439.6,265.2,435.6,228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M365.6,394.8c0.4-0.4,0.8-0.8,1.2-1.2c-0.4,0.8-0.4,1.6-0.8,2C366,396,365.6,395.6,365.6,394.8z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M429.2,338.8c-39.2,22.8-74.8,4.8-82.4,0c1.2-6,3.6-10.8,7.6-13.6c0,0,31.6,27.6,67.2,0 C425.2,328,427.6,332.8,429.2,338.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M423.6,393.6c0.4,0.4,0.8,0.8,1.2,1.2c0,0.8-0.4,1.2-0.4,1.2C424,395.2,424,394.4,423.6,393.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M482.4,365.2c-2.8-2-6-4-9.6-5.6l-43.6-21.2l0,0c-39.2,22.8-74.8,4.8-82.4,0l0,0l-43.6,21.2 c-15.2,7.2-26.4,20.4-31.6,36.4c-6.4,19.2-9.2,39.6-9.2,60v52C358.8,504.8,442,447.6,482.4,365.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M326.4,383.6c-16.4,0-30,13.2-30,30v90.8c72-12,134-54.8,171.6-114c-5.2-4-11.6-6.8-18.8-6.8 L326.4,383.6L326.4,383.6z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacement);
export default __webpack_public_path__ + "static/media/placement.57fcdb758c92f4cc0541f174165b66cd.svg";
export { ForwardRef as ReactComponent };